import React, { useState, useEffect } from "react";
import { useMediaQuery, Typography, Box, CircularProgress } from "@mui/material";
import {
  Timeline,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
  TimelineDot,
  TimelineConnector,
  TimelineContent,
} from "@mui/lab";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { getApiCall } from "../../../services/apiHelper";
import { baseUrl } from "../../../config/config";
import moment from "moment";
import { useParams } from "react-router-dom";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

type audit = {
  itemId: string | undefined | null;
  leaseNumber: string | undefined | null;
  userName: string | undefined | null;
  modifiedDate: Date;
  changedStatus: string | undefined | null;
  comments: string | undefined | null;
};

const AuditControl = () => {
  const { itemid }: any = useParams()

  const getAuditLogs = () => {
    var url = `${baseUrl}AuditLog/GetByLeaseId/${itemid}`;
    const res = getApiCall(url).then((data: any) => {
      return data.result;
    });
    return res;
  };

  const [auditLogsData, setAuditLogData] = React.useState<audit[]>([]);
  const [loading, setLoading] = React.useState<boolean>(true);

  useEffect(() => {
    setLoading(true);
    getAuditLogs().then((data: audit[]) => {
      data.sort(
        (objA, objB) => new Date(objB.modifiedDate).valueOf() - new Date(objA.modifiedDate).valueOf()
      );
      setAuditLogData([...data]);
      setLoading(false);
    });
  }, [itemid]);

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "1px solid #ccc",
          padding: "10px",
          overflowY: "auto",
        }}
      >
        <Box sx={{ width: "95%" }}>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
              <CircularProgress />
            </Box>
          ) : (
            <Timeline>
              {auditLogsData?.map((item) => (
                <TimelineItem key={item.itemId}>
                  <TimelineOppositeContent sx={{ flex: 1, textAlign: "right" }}>
                    <Typography color="textSecondary">
                      {moment(item.modifiedDate).format("MMM-DD-YYYY hh:mm A")}
                    </Typography>
                  </TimelineOppositeContent>
                  <TimelineSeparator>
                    <TimelineDot color="secondary" sx={{ bgcolor: "#2b8818" }} />
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent
                    sx={{
                      flex: 1,
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <Typography>
                      {item.changedStatus}
                    </Typography>
                    <Typography 
                      variant="caption"
                      sx={{ mb: "5px" }}>{item.userName}</Typography>
                      <div>
                    <Typography 
                      color="textSecondary"
                      variant="caption"
                      sx={{ mb: "5px" }}>{item.comments}</Typography>
                      </div>
                  </TimelineContent>
                </TimelineItem>
              ))}
            </Timeline>
          )}
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default AuditControl;
